<script>
import ApiRequest from "@/core/api-request";
import $ from 'jquery';

export default {
  name: "SelectBoxServer",
  emits: ['update:modelValue', 'update:modelObject', 'change'],
  props: {
    modelObject: null,
    modelValue: {
      default: '',
    },
    options: {
      default: {
        uri: '',
        resource: ''
      }
    },
    displayField: {
      default: 'name'
    },
    valueField: {
      default: 'id'
    },
    searchField: {
      default: 'name'
    },
    multiple: {
      default: true
    },
    required: Boolean,
    autoload: {
      default: false
    }
  },
  data() {
    return {
      id: 'sl_' + Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
      options_data: [],
      options_data_raw: [],
      selected_data: [],
      loading: false,
      pagination: {
        current_page: 0,
        total_pages: 0
      },
      search: {
        timeout_id: null,
        value: null
      }
    }
  },
  watch: {
    options_data_raw: {
      handler(newValue) {
        this.options_data = newValue.map((item) => {
          if (!item) return;
          let _item = {value: item[this.valueField]}
          if (typeof this.displayField === 'function') {
            _item.label = this.displayField(item)
          } else {

            _item.label = item[this.displayField]
          }
          return _item;
        });
      }
    },
    'search.value': {
      handler(newValue) {
        if (newValue) {
          this.fetch();
        }
      }
    },
    modelValue: {
      handler(newValue) {
        this.selected_data = newValue;
      },
      immediate: true
    },
    modelObject: {
      handler(newValue) {
        if (newValue) {
          let $this = this;
          let data = (newValue && newValue instanceof Array) ? newValue : [newValue];
          $this.options_data_raw = Array.from(new Set([...$this.options_data_raw, ...data.filter(item => !$this.options_data_raw.some(existingItem => existingItem[$this.valueField] === item[$this.valueField]))]));
        }
      },
      immediate: true
    },
    selected_data: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal);
        let objects = null;
        if (newVal) {
          if (this.options_data_raw.length > 0) {
            if (this.multiple) {
              objects = this.options_data_raw.filter((item) => {
                if (!item) {
                  return false
                }
                return item[this.valueField] === newVal
              })
            } else {
              objects = this.options_data_raw.find((item) => {
                if (!item) {
                  return false
                }
                return item[this.valueField] === newVal
              })
            }
          }
        }
        this.$emit('update:modelObject', objects);
        this.$emit('change', newVal)
      }
    },
    dependents: {
      deep: true,
      handler(newValue, oldValue) {
        this.pagination.current_page = 0;
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          if (this.dependents) {
            this.options_data_raw = (Array.isArray(this.modelObject)) ? this.modelObject : (this.modelObject ? [this.modelObject] : []);
          }
        }
      }
    }
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;
        let $this = this;
        let page = this.pagination.current_page === 0 ? 1 : this.pagination.current_page;
        let params = {
          include: $this.options.include,
          filterModel: {},
          pagination: true,
          size: 20,
          page: page
        };


        if (this.search.value) {
          params[this.searchField] = this.search.value
        }
        let response = await ApiRequest.get({
          uri: this.options.url,
          loadingE: false,
          params: params
        });
        let data = $this.options.resourceKey ? response[$this.options.resourceKey] : response;
        $this.options_data_raw = Array.from(new Set([...$this.options_data_raw, ...data.filter(item => !$this.options_data_raw.some(existingItem => existingItem[$this.valueField] === item[$this.valueField]))]));
        $this.pagination = response.meta.pagination;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }

    },
    onSearchChange(query) {
      if (this.search.timeout_id) {
        clearTimeout(this.search.timeout_id);
      }
      this.search.timeout_id = setTimeout(() => {
        this.search.value = query;
      }, 1000);

    },
    scrollFetch() {
      if (this.pagination.current_page === 0 || (this.pagination.current_page < this.pagination.total_pages)) {
        this.pagination.current_page += 1;
        this.fetch();
      }
    }
  },
  mounted() {
    let $this = this;
    $('#' + this.id + '-dropdown').on('scroll', function () {
      let element = $(this);
      if (element[0].scrollHeight - element.scrollTop() <= element.outerHeight()) {
        $this.scrollFetch();
      }
    });
  }
}
</script>

<template>
  <div class="input-group input-group-sm">
    <v-select class="form-control form-control"
              v-model="selected_data"
              :options="options_data"
              :searchable="true"
              :mode="multiple?'multiple':'single'"
              @open="autoload? ()=>{
                    if(this.pagination.current_page===0){
                        fetch();
                    }
                  }:()=>{

                  }
                  "
              @search-change="onSearchChange"
              ref="_select_box_multiple"
              :hideSelected="false"
              :loading="loading"
              :required="required"
              :closeOnSelect="!this.multiple"
              :noOptionsText="loading?'Đang tải...':'Không có dữ liệu.'"
              :id="id"
    >
      <template v-slot:multiplelabel="{ values }">
        <div class="multiselect-multiple-label">
          -- Đã chọn {{ values.length }}.
        </div>
      </template>
    </v-select>

    <span class="input-group-append" v-if="this.createForm">
         <button type="button" class="btn btn-outline-secondary btn-flat"
                 @click="$refs.createForm.show()"><i
             class="fal fa-plus"></i></button>
    </span>
  </div>
  <component v-if="this.createForm" ref="createForm" :is="createForm" :modal_id="'modal_' + id"
             @result="this.fetch()"></component>
</template>

<style scoped>

</style>
